import React from "react";
import "./Define.css";
import { useSelector, useDispatch } from "react-redux";
import { Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { setState } from "./defineSlice";
import {
   biWeeklyDepCols,
   noDepCols,
   summaryView,
   weeklyDepCols,
} from "./DefineQuotaBreakdownCols";

function DefineQuotaBreakdown() {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const {
      selectedRows,
      gridDataFiltered,
      selectedDepletion,
      selectedView
   } = define;

   function selectColumn() {
      if(selectedView === 2) {
         return summaryView;
      }
      if(selectedDepletion === null || selectedDepletion === undefined || selectedDepletion.value === undefined) {
         return noDepCols;
      }else{
      if (selectedDepletion.value === "Biweekly depletion") {
         return biWeeklyDepCols;
      }
      if (selectedDepletion.value === "No depletion") {
         return noDepCols;
      }
      return weeklyDepCols;
      }
   }

   return (
      <Grid container direction="column" spacing={2}>
         <Grid item sx={{ width: "100%" }}>
            <DataGrid sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: "normal"
          },
          "& .MuiDataGrid-columnHeader": {
            // Forced to use important since overriding inline styles
            height: "unset !important"
          },
          "& .MuiDataGrid-columnHeaders": {
            // Forced to use important since overriding inline styles
            maxHeight: "168px !important"
          }
        }}
               rows={gridDataFiltered}
               columns={selectColumn()}
               disableRowSelectionOnClick={true}
               checkboxSelection={true}
               onRowSelectionModelChange={(selRows) => {
                  dispatch(setState("selectedRows", selRows));
               }}
               rowSelectionModel={selectedRows}
               disableColumnMenu
               disableColumnFilter
               disableColumnSelector
            />
         </Grid>
      </Grid>
   );
}

export default DefineQuotaBreakdown;
